export default __webpack_public_path__ + "static/media/note-mention.b17935e1.svg";